// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1OL-r","info":"Note_info__juogX","note":"Note_note__2r686","actions":"Note_actions__2wyne"};